import { Button, ButtonProps, IconButton } from "@mui/material";
import { useStylesCss } from "./AppButtons.styles";
import { PropsWithChildren } from "react";

const CircleButton: React.FC<PropsWithChildren<ButtonProps>> = (props: PropsWithChildren<ButtonProps>) => {
  const classes = useStylesCss();
  const myClasses = { ...classes.circle, ...props.sx };
  const myProps = {
    ...props,
    sx: myClasses,
  };
  return (
    <IconButton variant="contained" {...myProps} color="primary">
      {props.children}
    </IconButton>
  );
};
export default CircleButton;
